import HeaderModuleTabs from './header-module-tabs'
import HeaderModuleDashTabs from './header-module-tabs-dash'
import HeaderModuleTitle from './header-module-title'

export const HeaderModule = {
  title: HeaderModuleTitle,
  tabs: HeaderModuleTabs,
  tabsDashboard: HeaderModuleDashTabs,
}
